/*
 * @Description: In User Settings Edit
 * @Author: Michael
 * @Date: 2019-06-15 11:05:40
 * @LastEditTime: 2023-03-23 10:56:01
 * @LastEditors: sunbingqing
 */
export default {
  routes: [
    {
      path: '/order/scheduleV5/page',
      name: 'order_scheduleV5',
      component: () => import('@/module/order/OrderSchedulePageV5.vue'),
      meta: {
        title: '在线约课',
        keepAlive: true,
        logined: false,
      },
    },
    {
      path: '/order/scheduleV5/detail',
      name: 'order_scheduleV5_detail',
      component: () => import('@/module/order/OrderScheduleDetailPageV5.vue'),
      meta: {
        title: '在线约课',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/order/scheduleV5/queue',
      name: 'order_scheduleV5_QueueDetail',
      component: () => import('@/module/order/studentCourseQueuePage/StudentQueueDetails.vue'),
      meta: {
        title: '在线约课',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/student/reserve/list',
      name: 'share_order_schedule',
      component: () => import('@/module/order/OrderScheduleInit.vue'),
      meta: {
        title: '在线约课',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/student/reserve/select-student',
      name: 'student_reserve_selected',
      component: () => import('@/module/order/SelectStudent.vue'),
      meta: {
        title: '选择学员',
        keepAlive: false,
        logined: false,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/Orders.js